<template>
  <div
    class="name-container text-left"
    :class="{ 'bg-off-white': darkBg }"
  >
    <div class="flex items-center justify-between">
      <h4
        class="max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-medium text-dark-gray"
      >
        {{ rate?.subject || '-' }}
      </h4>
    </div>

    <div class="mt-3 flex flex-col gap-2">
      <div class="flex justify-between">
        <p class="text-neutral-subtlest">Broker</p>
        <p class="text-neutral-subtle-bold">
          {{ rate?.issuer?.legal_name }}
        </p>
      </div>

      <div class="flex justify-between">
        <p class="text-neutral-subtlest">Created By</p>
        <p class="text-neutral-subtle-bold">
          {{ rate?.creator?.full_name }}
        </p>
      </div>

      <div class="flex justify-between">
        <p class="text-neutral-subtlest">Created At</p>
        <p class="text-neutral-subtle-bold">
          {{ createdAt(rate?.created_at) }}
        </p>
      </div>

      <div class="flex">
        <p
          class="rounded-md bg-blue-100 px-2 font-medium capitalize text-blue-800"
          :class="{
            'bg-green-100 !text-green-800': rate.status === 'accepted',
          }"
        >
          {{ rateStatus(rate.status) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import dayjs from 'dayjs';

export default {
  name: 'Rate Confirmation Card',
  props: {
    rate: Object,
    darkBg: {
      default: false,
    },
  },
  emits: ['accept-terms'],
  methods: {
    createdAt(date) {
      return dayjs(date).format('h:mm a on M/D/YYYY');
    },
    acceptTerms(rate) {
      this.$emit('accept-terms', rate);
    },
    rateStatus(status) {
      if (status === 'delivered') {
        return 'new';
      } else {
        return status;
      }
    },
  },
};
</script>

<style scoped>
.name-container {
  padding: 12px 14px;
}

.review-button {
  @apply mt-4 w-full cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark;
  padding: 8.5px 0px !important;
}

.review-button:disabled {
  @apply border-light-gray bg-white text-light-gray !important;
}
</style>
